import { useQuery } from "@tanstack/react-query"

import { client } from "@/api"
import queryKeys from "@/api/queryKeys"

function useGetMapEvents({
  filters,
}: {
  filters: {
    filter: string[]
    searchValue: string
    petFriendly: string
    ageRange: string
    price: string
    bounds?: {
      north: number
      south: number
      east: number
      west: number
    }
  }
}) {
  return useQuery({
    queryKey: queryKeys.events.mapPage({
      searchValue: filters.searchValue,
      filter: [...filters.filter],
      petFriendly: filters.petFriendly,
      ageRange: filters.ageRange,
      price: filters.price,
      bounds: filters.bounds,
    }).queryKey,
    queryFn: () =>
      client
        .get(`/events/map`, {
          params: {
            searchValue: filters.searchValue,
            filter: [...filters.filter],
            petFriendly: filters.petFriendly,
            ageRange: filters.ageRange,
            price: filters.price,
            bounds: filters.bounds,
          },
          paramsSerializer: { indexes: true },
        })
        .then((response) => response.data),
  })
}
export default useGetMapEvents
